import {
  PRICES_CORRECT_PERMISSION,
  PRICES_REGISTER_PERMISSION,
} from '@/core/config/auth-permissions.config';
import type { DrawerRouteDef } from '@/core/drawer-route.util';

/** The `data.drawer` id of the price register drawer — `/prices/new`. */
export const PRICE_DRAWER_REGISTER = 'register';

/** The `data.drawer` id of the price correction drawer — `/prices/:priceId/correct`. */
export const PRICE_DRAWER_CORRECT = 'correct';

/**
 * The Prices screen's deep-link drawer inventory (DAG node (e)).
 *
 * Both drawers are form-bearing (a dirty draft must not be discarded silently)
 * and both carry the screen's OWN action-permission constants — the same tuples
 * the header button and the row menu gate on, referenced and never copied. The
 * screen has no edit form, so no plain `/:id` record is generated; delete keeps
 * its in-memory confirmation (no URL by decision).
 *
 * The `:id` path parameter name is the reserved one the shared `activeDrawer`
 * helper reads — the URL segment itself is the `price_id`.
 */
export const PRICES_DRAWER_DEFS: readonly DrawerRouteDef[] = [
  {
    path: 'new',
    drawer: PRICE_DRAWER_REGISTER,
    permission: PRICES_REGISTER_PERMISSION,
    veto: true,
  },
  {
    path: ':id/correct',
    drawer: PRICE_DRAWER_CORRECT,
    permission: PRICES_CORRECT_PERMISSION,
    veto: true,
  },
];
